import PropTypes from "prop-types";
import React, { Component } from "react";
import { Grid, CircularProgress } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import styled from "styled-components";
import { withAlert } from "react-alert";
import { withTranslation } from "react-i18next";
import BackButton from "../../components/BackButton";
import CollapseGroup from "../../waybee-ui/CollapseGroup";
import SubGroup from "../../waybee-ui/SubGroup";
import ClassService from "../../services/ClassService";
import Group from "../../waybee-ui/Group";
import SearchableSelect from "../../waybee-ui/SearchableSelect";
import GradesDialog from "./GradesDialog";

const LoadContainer = styled.div`
  width: 100%;
  text-align: center;
  padding: 32px 8px;
`;

class ReleaseNotes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      classId: null,
      filter: {
        name: "",
        course: ""
      },
      loadingCourses: false,
      courses: [],
      loadingExams: false,
      exams: [],
      selectedExam: null
    };
  }

  componentDidMount() {
    this.getCourses();
  }

  setFilter(field, value) {
    const { filter } = this.state;
    this.setState({
      filter: {
        ...filter,
        [field]: value
      }
    });
  }

  getCourses = async () => {
    const { match, alert, t } = this.props;
    this.setState({ loadingCourses: true });

    const classId = match.params.id;
    try {
      const disciplines = await ClassService.getDisciplines(classId);
      /* setState é assíncrono: chamar getExams no callback para filter.course já existir */
      this.setState(
        prev => ({
          classId,
          courses: disciplines || [],
          filter:
            disciplines && disciplines.length
              ? { ...prev.filter, course: disciplines[0] }
              : prev.filter
        }),
        () => {
          if (disciplines && disciplines.length) {
            this.getExams();
          }
        }
      );
    } catch (e) {
      console.error(e);
      alert.show(t("common.messages.errorFetchDisciplines"), {
        title: t("common.actions.error")
      });
    } finally {
      this.setState({ loadingCourses: false });
    }
  };

  getExams = async () => {
    const { alert, t } = this.props;
    const { filter } = this.state;
    this.setState({ loadingExams: true });

    if (filter && filter.course) {
      try {
        const exams = await ClassService.getExams(filter.course.idTurmaDisc);
        this.setState({ exams });
      } catch (e) {
        console.error(e);
        alert.show(t("grades.v1.errorTests"), {
          title: t("common.actions.error")
        });
      } finally {
        this.setState({ loadingExams: false });
      }
    } else {
      this.setState({ loadingExams: false });
    }
  };

  changeCourse = course => {
    this.setState(
      prev => ({
        filter: {
          ...prev.filter,
          course: course || null
        }
      }),
      () => this.getExams()
    );
  };

  onClickExam = exam => {
    const { filter } = this.state;

    this.setState({
      selectedExam: {
        ...exam,
        idTurmaDisc: filter.course.idTurmaDisc
      }
    });
  };

  onCloseGradesModal = () => {
    this.setState({ selectedExam: false });
  };

  render() {
    const { t } = this.props;
    const {
      filter,
      loadingCourses,
      courses,
      classId,
      loadingExams,
      exams,
      selectedExam
    } = this.state;

    return (
      <Grid container spacing={2}>
        <BackButton to={`/classes/${classId}`} />

        <Grid item xs={12}>
          <Group fullWidth>
            {loadingCourses ? (
              <LoadContainer>
                <CircularProgress />
              </LoadContainer>
            ) : (
              <Grid container item xs={4}>
                <SearchableSelect
                  label={t("common.labels.discipline")}
                  options={courses}
                  value={filter.course || null}
                  onChange={this.changeCourse}
                  disableClearable
                  getOptionLabel={o => o.name || ""}
                  getOptionSelected={(a, b) =>
                    String(a.idTurmaDisc) === String(b.idTurmaDisc)}
                  noOptionsText={t("common.messages.noDiscipline")}
                />
              </Grid>
            )}
          </Group>
        </Grid>

        {loadingExams ? (
          <LoadContainer>
            <CircularProgress />
          </LoadContainer>
        ) : (
          filter.course &&
          exams.map(step => (
            <Grid item xs={12} key={step.id}>
              <CollapseGroup title={step.name}>
                {step.exams.map(exam => (
                  <SubGroup
                    key={exam.id}
                    title={exam.name}
                    icon="chevron_right"
                    onClick={() => this.onClickExam(exam)}
                  />
                ))}
              </CollapseGroup>
            </Grid>
          ))
        )}

        <GradesDialog
          selectedExam={selectedExam}
          classId={classId}
          course={filter.course}
          onClose={this.onCloseGradesModal}
        />
      </Grid>
    );
  }
}

ReleaseNotes.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string
    })
  }).isRequired,
  alert: PropTypes.shape({
    show: PropTypes.func
  }).isRequired,
  t: PropTypes.func.isRequired
};

export default withTranslation()(withAlert()(withRouter(ReleaseNotes)));
